<template>

	<b-container fluid class="bg-gray breadcrumb-container py-2 px-3">
		<b-container>
			<b-breadcrumb :items="breadcrumbsList"></b-breadcrumb>
		</b-container>
	</b-container>

</template>

<script>

	export default {
		data() {
			return {
				// Replace navigation link titles with a different name
				aliases: [
					{
						replace: '/shop',
						with: 'Products'
					},
					{
						replace: '/my-account/view-order',
						with: 'Orders',
						to: '/my-account/orders'
					},
					{
						replace: '/my-account/view-subscription',
						with: 'Subscriptions',
						to: '/my-account/subscriptions'
					},
					{
						replace: '/product-category',
						href: '/products'
					},
					{
						replace: '/products/hgh-boost',
						with: 'HGH Boost'
					},
					{
						replace: '/products/bcaas',
						with: 'BCAAS'
					},
					{
						replace: '/products/burn-pm',
						with: 'Burn PM'
					}
				],

				// Generated automatically
				breadcrumbsList: []
			}
		},

		watch: {
			$route(to, from) {
				this.generateBreadcrumbs();
			}
		},

		mounted() {
			this.generateBreadcrumbs();
		},

		methods: {
			generateBreadcrumbs: function() {
				let url = window.location.href;
				let here = url
					.replace(/(\?.*)$/, '') // Remove parameters
					.replace(/\/$/, '')     // Remove slash from end of url
					.replace(/#(.+)/, '')   // Remove hash from end of url
					.split('/')             // Split url segments into array
					.slice(3);              // Remove first 3 segments (protocal, slash, domain)

				// Start with home segment
				let parts = [{
					text: 'Home',
					href: '/'
				}];

				// Push each segment to array
				for (let i = 0; i < here.length; i++) {
					let part = here[i];
					let pageName = part.toLowerCase();
					pageName = part.charAt(0).toUpperCase() + part.slice(1);
					let link = '/' + here.slice(0, i + 1).join('/');
					parts.push({
						text: pageName,
						href: link
					});
				}

				for (let i = 0; i < parts.length; ++i) {
					let part = parts[i];
					let alias = this.aliases.find(alias => alias.replace === part.href);
					if (!!alias) {
						// Replace text
						part.text = alias.with ? alias.with : this.formatBreadcrumb(part.text);

						// Replace href / to
						part.href = alias.href ? alias.href : part.href;
						part.to = alias.to ? alias.to : part.to;
					} else {
						part.text = this.formatBreadcrumb(part.text);
					}
				}

				this.breadcrumbsList = parts;
			},

			formatBreadcrumb(text) {
				return text.replace(/(-|^)([^-]?)/g, (_, prep, letter) => (prep && ' ') + letter.toUpperCase());
			}
		}
	}

</script>

<style scoped>
	
	.bg-gray {
		background-color: #F8F9FA;
	}

	.breadcrumb-container {
		border-bottom: 1px solid #ededed;
	}

/*	.breadcrumb-item.active{
		text-transform: capitalize;
	}*/

	.breadcrumb {
		padding: 0;
		margin-bottom: 0;
		background-color: transparent;
	}

	.breadcrumb-item + .breadcrumb-item::before{
		content:"»";
	}

	a {
		color: #cf0614;
	}

</style>
